import { DiTokens } from "../../services/diTokens";
import { Action, Module, Mutation, VuexModule } from "vuex-module-decorators";
import { container } from "@/inversify.config";
import ITemplatesService from "../../services/templates/ITemplatesService";
import { TemplateData } from "../../data/templateData";

@Module({
  name: "templates",
  namespaced: true
})
export class TemplatesStore extends VuexModule {
  get templatesService(): ITemplatesService {
    return container.get<ITemplatesService>(DiTokens.TemplatesService);
  }

  /** Список непериодических шаблонов */
  public simpleTemplates: Array<TemplateData> = [];

  /**Список периодических шаблонов */
  public periodTemplates: Array<TemplateData> = [];

  /** Признак загрузки шаблонов */
  public templatesLoading: boolean = true;

  public static getDefaultState: Function = () => {
    return {
      simpleTemplates: [],
      periodTemplates: [],
      templatesLoading: true  
    }
  };

  @Mutation
  setLoading(loading: boolean) {
    this.templatesLoading = loading;
  }

  @Mutation
  resetStates() {
    Object.assign(this, TemplatesStore.getDefaultState());
  }

  @Mutation
  setTemplates(params: any) {
    this.simpleTemplates = params.simple ?? [];
    this.periodTemplates = params.period ?? [];
  }

  @Action
  async fetchTemplates() {
    this.setLoading(true);
    const temps: Array<TemplateData> = await this.templatesService.fetchTemplates();
    const simpleTemplates = temps.filter((t: TemplateData) => !t.Period);
    const periodTemplates = temps.filter((t: TemplateData) => t.Period);
    this.setTemplates({ simple: simpleTemplates, period: periodTemplates });
    this.setLoading(false);
  }
}
